/** --------------------------------------------------
*
*   pages - overview page
*   OVERVIEW PAGE SCROLL FACETS
*
*  -------------------------------------------------- */

(function ($, Drupal, duo) {
  Drupal.behaviors.overview_page_scroll_facets = {

    attach: function (context, settings) {
      const self = this;

      // only do the following once:
      $(document, context).once('overview_page_scroll_facets').each(function() {
        self.init(context, settings);
      });
    },

    init: function(context, settings) {
      const self = this;

      // setup sliders:
      self.setupSliders();
    },

    setupSliders() {
      const self = this;

      let ticking = false;
      const hasNativeSmoothScroll = duo.Utils.testSupportsSmoothScroll;

      // process the slider navigation:
      const $sliderBlocks = $(document).find('.overview-page-content-main-filters .facets-widget-links');
      $sliderBlocks.each(function(index, element) {
        const $sliderBlock = $(element);
        const scrollableElement = $sliderBlock.find('.item-list__links')[0];

        /* process slides */
        /* ************** */

        // count the number of slide items:
        const $slides = $sliderBlock.find('.facet-item');
        const slidesLength = $slides.length;

        if(slidesLength > 0) {

          // add an ID to every slide item:
          const starterId = 'f-slider-' + duo.Utils.uniqueId;
          $slides.each(function(i, e) {
            const $slide = $(e);
            $slide.attr('id', starterId + '-' + i);
          });

          /* slider navigation */
          /* ***************** */

          // create a navigation zone:
          let $navZone = $('<nav class="f-slider-nav"></nav>');

          // navigation arrows:
          let $sliderPrevBtn = $('<button>', {
            'class': 'f-slider-nav__btn f-slider-nav__btn--prev',
            'type': 'button',
            html: '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M8 9.5v-9L2 5z" /></svg>' +
                  `<span class="visually-hidden">${Drupal.t('previous')}</span>`
          });
          let $sliderNextBtn = $('<button>', {
            'class': 'f-slider-nav__btn f-slider-nav__btn--next',
            'type': 'button',
            html: '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M8 5 2 .5v9z" /></svg>' +
                  `<span class="visually-hidden">${Drupal.t('next')}</span>`
          });
          let $sliderNav = $('<div>', {'class': 'f-slider-nav-arrows'}).append($sliderPrevBtn, $sliderNextBtn);
          $navZone.append($sliderNav);

          // arrow events:

          $sliderPrevBtn.on('click', function() {
            const button_is_disabled = $(this).attr('aria-disabled');
            if(button_is_disabled === undefined) {
              if(!$sliderPrevBtn.hasClass('js-busy')) {

                // -> scroll one screen:
                const scrollTarget = scrollableElement.scrollLeft - scrollableElement.clientWidth / 2;
                duo.Utils.smoothScroll(scrollableElement, scrollTarget, true, hasNativeSmoothScroll);

                // -> prevent "fast clicks" on the button:
                $sliderPrevBtn.addClass('js-busy');
                setTimeout(function(){
                  $sliderPrevBtn.removeClass('js-busy');
                }, 350);
              }
            }
          });

          $sliderNextBtn.on('click', function() {
            const button_is_disabled = $(this).attr('aria-disabled');
            if(button_is_disabled === undefined) {
              if(!$sliderNextBtn.hasClass('js-busy')) {

                // -> scroll one screen width:
                const scrollTarget = scrollableElement.scrollLeft + scrollableElement.clientWidth / 2;
                duo.Utils.smoothScroll(scrollableElement, scrollTarget, true, hasNativeSmoothScroll);

                // -> prevent "fast clicks" on the button:
                $sliderNextBtn.addClass('js-busy');
                setTimeout(function(){
                  $sliderNextBtn.removeClass('js-busy');
                }, 350);
              }
            }
          });

          // add navzone to block:
          $sliderBlock.append($navZone);

          // check navigation button states:
          self.checkButtonStates(scrollableElement);

          // navigation events:
          scrollableElement.addEventListener('scroll', (e) => {
            if (!ticking) {
              window.requestAnimationFrame(function() {

                // update navigation buttons:
                self.checkButtonStates(scrollableElement);

                ticking = false;
              });
              ticking = true;
            }
          });

          // check for navigation visibility:
          self.checkNavVisibility(scrollableElement);
          const timeoutId = 'slider' + duo.Utils.uniqueId;
          let timeout = false;
          $(window).once(`slider-${timeoutId}`).on(`resize.${timeoutId}`, function() {
            clearTimeout(timeout);
            timeout = setTimeout(self.checkNavVisibility(scrollableElement), 250);
          });
        }
      });
    },

    checkButtonStates: function(sliderInstance) {
      const $parentBlock = $(sliderInstance).parents('.facets-widget-links');

      const clientWidth = sliderInstance.clientWidth;
      const sliderWidth = sliderInstance.scrollWidth;
      const maxScroll = sliderWidth - clientWidth;
      const currentScroll = sliderInstance.scrollLeft;
      const $sliderPrev = $parentBlock.find('.f-slider-nav__btn--prev');
      const $sliderNext = $parentBlock.find('.f-slider-nav__btn--next');

      // allow the scroll to be a few pixels off,
      // since the browser might not precisely scroll
      // to the "0" or "maxScroll" positions:
      const allowance = 5;

      if (currentScroll <= allowance) {
        $sliderPrev.attr('aria-disabled', 'true');
      } else {
        $sliderPrev.removeAttr('aria-disabled');
      }

      if (currentScroll >= maxScroll - allowance) {
        $sliderNext.attr('aria-disabled', 'true');
      } else {
        $sliderNext.removeAttr('aria-disabled');
      }
    },

    checkNavVisibility: function(sliderInstance) {
      const $sliderInstance = $(sliderInstance);
      const $parentBlock = $sliderInstance.parents('.facets-widget-links');
      const $navArrowsBlock = $parentBlock.find('.f-slider-nav-arrows');

      const clientWidth = sliderInstance.clientWidth;
      const sliderWidth = sliderInstance.scrollWidth;

      if(sliderWidth > clientWidth ) {
        $sliderInstance.addClass('js-overflow');
        $navArrowsBlock.addClass('js-visible');
      } else {
        $sliderInstance.removeClass('js-overflow');
        $navArrowsBlock.removeClass('js-visible');
      }

      // check button states:
      this.checkButtonStates(sliderInstance);
    }
  };
})(jQuery, Drupal, window.duo = window.duo || {});
